/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_User_CreateInputs */

const cs_audit_key_user_create = /** @type {(inputs: Audit_Key_User_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel vytvořen`)
};

const en_audit_key_user_create = /** @type {(inputs: Audit_Key_User_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User created`)
};

/**
* | output |
* | --- |
* | "User created" |
*
* @param {Audit_Key_User_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_user_create = /** @type {((inputs?: Audit_Key_User_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_User_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_user_create(inputs)
	return cs_audit_key_user_create(inputs)
});